<template>
  <v-container class="bg-section mb-16 py-16" fluid>
    <v-row>
      <v-col cols="10" :md="6" class="pl-1 ml-8 pl-md-16 ml-md-16 pl-lg-16 ml-lg-16">
        <h6>INFORMA A TU CLIENTE CON DATOS PRECISOS</h6>
        <h2 class="mr-14 mb-6">
          Ayuda a tus clientes a alcanzar sus objetivos
        </h2>
        <p class="">
          Deja de picar datos a mano y ofrece un asesoramiento real y de valor.
        </p>
      </v-col>
      <v-col cols="12" :sm="6" :md="2" class="bg-card mr-md-4 mr-lg-4 text-center">
        <v-img
          :src="require(`@/assets/consultants/person-files.png`)"
          height="160px"
        ></v-img>
        <h6 class="mt-6">
          Crea informes automáticos y personalizados en un clic.
        </h6>
      </v-col>
      <v-col cols="12" :sm="6" :md="2" class="bg-card mx-md-4 mx-lg-4 text-center">
        <v-img
          :src="require(`@/assets/consultants/persons-clap.png`)"
          height="160px"
        ></v-img>
        <h6 class="mt-6">
          Desarrolla servicios de más valor para tus clientes.
        </h6>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelpClients",

  data: () => ({}),
};
</script>

<style scoped>
.bg-card {
  background: #ffffff;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.12);
  border-radius: 20px;
}
</style>
